module.exports = __webpack_public_path__ + "img/mineBomb.12df897e.png";